module.exports = __webpack_public_path__ + "./images/506d6619aa0876581c8e65c12306482b.webp";